export default "__VITE_ASSET__CoW2tqJa__ 288w, __VITE_ASSET__BIHNydEs__ 432w, __VITE_ASSET__CC4Gp26M__ 576w";